import React from 'react';
import Spinner from 'react-spinkit';
import './full-screen-carousel-item.scss';
import { fireAnalytics, getQualityFlag, getMuteFlag } from '../../pages/utils';
import { setInterval } from 'timers';

export default class Artwork extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      artwork: props.artwork,
      showLoader: true,
      mute: getMuteFlag(),
      highquality: getQualityFlag(),
      posterImage: true,
      downloadInfo: false,
    };
    this.getArtworkUrl = this.getArtworkUrl.bind(this);
    this.getArtworkVideoUrl = this.getArtworkVideoUrl.bind(this);
    this.downloadInfoText = '';
    this.virtualRoot = 'downloads';
    this.storagePath = '/Blackdove/';
    this.tempStoragePath = '/bdDownload';
    this.tempRoot = 'downloads';
    this.filePrefix = 'bdFile_';
    this.playingVideoId = null;
    this.bdDirectory = null;
    this.downloadDir = null;
    this.downloadTimeout = null;
    this.prevVideoID = '';
    this.id = null;
    this.downloadQueueObj = [];
    this.downloadedVideoArray = [];
    this.currentlyPlayingId = '';
    this.currentlyDownloadingId = '';
    this.startDownloading = true;
    this.downloadVideo = false;
    this.checkDownloadVideoTimeout = null;
    this.prevUrl = props.artwork.media.video.dash;
    this.isUSBAvailable = false;
    this.USBPath = '';
  }

  componentDidMount() {
    const video = document.getElementById('video');
    const poster = document.getElementById('poster');
    if (this.props.artwork.sourceFile !== null) {
      // Assuming ImageRotated roates by 270 deg and VideoRotated rotates by 90 deg
      if (window.innerWidth > window.innerHeight) {
        // screen is in LANDSCAPE orientation
        if (this.props.artwork.sourceFile.metadata.aspectRatio === '9:16') {
          // artwork is PORTRAIT hence APPLY rotation by 270 deg
          poster.classList.add('ImageRotated');
          video.classList.add('ImageRotated');
        } else if (this.props.artwork.sourceFile.metadata.aspectRatio === '1:1') {
          // artwork is SQUARE hence REMOVE rotation
          poster.classList.remove('ImageRotated');
          video.classList.remove('ImageRotated');
          video.style.objectFit = 'contain';
          poster.style.objectFit = 'contain';
        } else if (this.props.artwork.orientation === 'portrait') {
          poster.classList.add('ImageRotated');
        } else {
          // artwork is LANDSCAPE hence REMOVE rotation
          poster.classList.remove('ImageRotated');
          video.classList.remove('ImageRotated');
          poster.classList.remove('VideoRotated');
          video.classList.remove('VideoRotated');
          video.style.objectFit = 'cover';
        }
      } else {
        // screen is in PORTRAIT orientation
        if (this.props.artwork.sourceFile.metadata.aspectRatio === '1:1') {
          // artwork is SQUARE hence REMOVE rotation
          poster.classList.remove('ImageRotated');
          video.classList.remove('ImageRotated');
          poster.classList.remove('VideoRotated');
          video.classList.remove('VideoRotated');
          video.style.objectFit = 'contain';
          poster.style.objectFit = 'contain';
        } else if (this.props.artwork.sourceFile.metadata.aspectRatio === '9:16') {
          // artwork is PORTRAIT hence REMOVE rotation
          poster.classList.remove('VideoRotated');
          video.classList.remove('VideoRotated');
          video.style.objectFit = 'cover';
          poster.style.objectFit = 'cover';
        } else if (
          this.props.artwork.sourceFile.metadata.aspectRatio === '16:9' &&
          this.props.artwork.orientation !== 'portrait'
        ) {
          // artwork is LANDSCAPE hence APPLY rotation by 90 deg
          poster.classList.add('VideoRotated');
          video.classList.add('VideoRotated');
          video.style.objectFit = 'cover';
          poster.style.objectFit = 'cover';
        } else if (
          this.props.artwork.sourceFile.metadata.aspectRatio === '16:9' &&
          this.props.artwork.orientation === 'portrait'
        ) {
          // This is same as above... is it needed..?
          poster.classList.remove('VideoRotated');
          video.classList.add('VideoRotated');
          video.style.objectFit = 'cover';
          poster.style.objectFit = 'cover';
        }
      }
    }
    this.interval = setInterval(() => {
      if (this.state.mute != getMuteFlag()) {
        this.setState({
          mute: getMuteFlag(),
        });
      }
    }, 3000);
    // this.getUSBInfo();
    // this.createDir();
    // const video = document.getElementById('video');
    // video.onwaiting = () => {
    //   this.setState({ showLoader: true, isCurrent: true });
    // };
    video.onplaying = () => {
      // if(video.videoWidth === video.videoHeight) {
      //   document.getElementById("poster").style.objectFit = "contain";
      //   document.getElementsByTagName('video')[0].style.objectFit = "contain";
      // } else {
      //   document.getElementById("poster").style.objectFit = "cover";
      //   document.getElementsByTagName('video')[0].style.objectFit = "cover";
      // }
      // if ((window.innerWidth <= window.innerHeight) && (video.videoWidth > video.videoHeight)) {
      //   const v = document.getElementsByTagName('video');
      //   v[0].classList.add("VideoRotated");
      // } else if ((window.innerWidth >= window.innerHeight) && (video.videoWidth < video.videoHeight)) {
      //   const v = document.getElementsByTagName('video');
      //   v[0].classList.add("VideoRotated");
      // } else {
      //   const v = document.getElementsByTagName('video');
      //   v[0].classList.remove("VideoRotated");
      // }
      setTimeout(() => {
        this.setState({ posterImage: false });
      }, 1000);
    };
    window.addEventListener('online', this.handleConnectionChangePlayer);
    window.addEventListener('offline', this.handleConnectionChangePlayer);
  }

  getUSBInfo() {
    const that = this;
    tizen.filesystem.listStorages(
      function (storages) {
        for (var i = 0; i < storages.length; i++) {
          console.log(storages[i]);
          if (storages[i].type == 'EXTERNAL' && storages[i].state == 'MOUNTED') {
            console.log('USB Info : ', storages[i].label);
            that.isUSBAvailable = true;
            tizen.filesystem.resolve(storages[i].label, function (removableStorage) {
              that.createDirectoryUSB(removableStorage);
              that.USBPath = removableStorage.path;
            });

            break;
          }
        }
      },
      function (error) {
        console.log('USB Fetch Error', error);
      }
    );
  }

  handleConnectionChangePlayer(event) {
    if (event.type == 'offline') {
      // clearInterval(this.interval);
      this.checkDownloadVideoTimeout = setTimeout(() => {
        // if (!this.downloadVideo)
        // this.checkFile();
      }, 10000);
    }
    if (event.type == 'online') {
      if (this.downloadQueueObj.length > 0) {
        this.downloadQueueObj.shift();
      }
      this.startDownload = true;
      clearTimeout(this.checkDownloadVideoTimeout);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  playOfflineVideo(url) {
    console.log('URL TO Play : ', url);
    var video = document.getElementById('video');
    video.src = url;
    video.load();
    video.play();
    setTimeout(() => {
      this.setState({ posterImage: false });
    }, 1000);
  }

  startDownload(url, destination, filename) {
    // if (this.id != null) {
    //   platform.log('download > start > a  download is already in progress. returning back', 1);
    //   return;
    // }
    this.startDownloading = false;
    this.currentlyDownloadingId = filename;
    console.log(`downloads > Downloading the file > ${filename}`, 1);

    const req = new tizen.DownloadRequest(url, destination, filename, 'ALL');
    req.httpHeader.Pragma = 'no-cache';

    const listener = {
      oncompleted: this.onComplete.bind(this),
      onfailed: this.onFailed.bind(this),
    };

    this.id = tizen.download.start(req, listener);
  }

  onComplete(id, fullPath) {
    this.downloadInfoText = 'Download Complete';
    this.setState({ downloadInfo: true });
    setTimeout(() => {
      this.setState({ downloadInfo: false });
    }, 3000);
    this.setState({ posterImage: true });
    this.id = null;
    console.log('Path downloaded : ', fullPath);
    console.log(`download > Download completed: ${fullPath}`, 1);
    console.log('Download Queue Length : ', this.downloadQueueObj.length);
    if (this.downloadedVideoArray.length < 1) {
      this.downloadedVideoArray.push(this.currentlyDownloadingId);
    } else {
      let fileName = this.downloadedVideoArray[0];
      this.bdDirectory.deleteFile(`file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`);
      this.downloadedVideoArray.shift();
      this.downloadedVideoArray.push(this.currentlyDownloadingId);
    }
    if (this.downloadQueueObj.length >= 1) {
      console.log('Que Object : ', this.downloadQueueObj);
      let path = 'downloads/Blackdove';
      let durl = this.downloadQueueObj[0].media.video.full['4k'].mp4;
      this.checkFileExists(durl, path, this.downloadQueueObj[0].id);
      this.downloadQueueObj.shift();
    } else {
      this.startDownloading = true;
    }
    if (this.currentlyPlayingId === this.currentlyDownloadingId) {
      console.log('Playing Offilne Video');
      this.downloadVideo = true;
      this.playOfflineVideo(fullPath);
    } else {
      console.log('Currently Playing and downloaded are not same');
    }
    // const fileName = fileSystem.getFilename(fullPath);
    // fileSystem.moveTempFile(fileName);
  }

  onFailed() {
    this.id = null;
    console.log('Download fail: ' + error);
  }

  checkFileExists(durl, path, fileName) {
    console.log('Download URL : ', durl, '  Path : ', path, ' File Name : ', fileName);
    const that = this;
    console.log(
      'filesystem > Checking for file: ' + `file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`
    );
    if (this.isUSBAvailable) {
      tizen.filesystem.resolve(
        `${that.USBPath}${fileName}.mp4`,
        (file) => {
          console.log('File Found! Starting Offline Playback', file);
          const videoFilePath = `${that.USBPath}${fileName}.mp4`;
          console.log('fileSystem > checkFileExists > File found: ' + videoFilePath);
          that.downloadVideo = true;
          that.playOfflineVideo(videoFilePath);
          // fileFoundCallback(videoFilePath);
        },
        (e) => {
          console.log('File Not Found! Starting Download');
          that.startDownload(durl, that.USBPath, fileName);
        }
      );
    } else {
      tizen.filesystem.resolve(
        `file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`,
        (file) => {
          console.log('File Found! Starting Offline Playback', file);
          const videoFilePath = `file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`;
          console.log('fileSystem > checkFileExists > File found: ' + videoFilePath);
          that.downloadVideo = true;
          that.playOfflineVideo(videoFilePath);
          // fileFoundCallback(videoFilePath);
        },
        (e) => {
          console.log('File Not Found! Starting Download');
          that.startDownload(durl, path, fileName);
        }
      );
    }
  }

  checkFile() {
    if (this.downloadedVideoArray.length >= 1) {
      let fileName = this.downloadedVideoArray[0];
      const that = this;
      console.log(
        'filesystem > Checking for file: ' + `file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`
      );
      tizen.filesystem.resolve(
        `file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`,
        (file) => {
          const videoFilePath = `file:///opt/usr/home/owner/content/Downloads/Blackdove/${fileName}.mp4`;
          console.log('fileSystem > checkFileExists > File found: ' + videoFilePath);
          that.downloadVideo = true;
          that.playOfflineVideo(videoFilePath);
          // fileFoundCallback(videoFilePath);
        },
        (e) => {
          console.log('Offline File Not Found');
          if (that.downloadQueueObj.length > 0) {
            that.downloadQueueObj.shift();
          }
          that.props.history.push(`/error`);
        }
      );
    } else {
      this.downloadInfoText = 'No Offline Video Available';
      this.setState({ downloadInfo: true });
      if (this.downloadQueueObj.length > 0) {
        this.downloadQueueObj.shift();
      }
      setTimeout(() => {
        this.setState({ downloadInfo: false });
        this.props.history.push('/error');
      }, 3000);
    }
  }

  getArtworkUrl(artwork) {
    // const { showImage } = this.props;
    // if (!showImage) return '';
    if (
      artwork &&
      artwork.media &&
      artwork.media.image &&
      artwork.media.image.low &&
      artwork.media.image.low.landscape
    ) {
      return artwork.media.image.low.landscape || artwork.media.image.low;
    }
    return '';
  }

  getArtworkVideoUrl(artwork) {
    const { isCurrent, nxtPre, other } = this.props;
    if (isCurrent || nxtPre || other) {
      if (this.downloadTimeout !== null) {
        clearTimeout(this.downloadTimeout);
      }
      // let url = artwork.media.video.dash;
      let url = artwork.media.video.full['4k'].mp4;
      // this.downloadTimeout = setTimeout(() => {
      //   console.log("Inside Download");
      //   let path = 'downloads/Blackdove';
      //   if (navigator.onLine && this.startDownloading) {
      //     console.log("Checking File to start download");
      //     this.checkFileExists(durl, path, artwork.id);
      //   } else {
      //     console.log("Adding file to queue");
      //     if (this.downloadQueueObj.length < 1) {
      //       this.downloadQueueObj.push(artwork);
      //     } else {
      //       this.downloadQueueObj.shift();
      //       this.downloadQueueObj.push(artwork);
      //     }
      //   }
      // }, 15000);
      if (isCurrent && this.prevUrl !== url) {
        this.prevUrl = url;
        fireAnalytics('PlayVideo', 'Play', url);
      }
      return url;
    }
    return '';
  }

  createDir() {
    console.log('Creating Directory');

    tizen.filesystem.resolve(
      this.virtualRoot,
      (dir) => {
        this.bdDirectory = dir.createDirectory('Blackdove');
        console.log('Dir : ', dir);
        this.listDirectory();
      },
      (e) => {
        console.log(`filesystem > createBDDirectory > Error ${e.message}`);
        tizen.application.getCurrentApplication().exit();
      },
      'rw'
    );
  }

  createDirectory(usb) {
    try {
      usb.createDirectory('Blackdove');
      console.log('USB Directory created sucessfully');
    } catch (e) {
      console.log('USB Directory created fail', e);
    }
  }

  listDirectory() {
    console.log('Inside Directory Listing');
    tizen.filesystem.resolve(
      this.virtualRoot,
      (dir) => {
        // this.downloadDir = dir;
        dir.listFiles(
          (files) => {
            console.log(`list files > ${files}`);
            // for (let i = 0; i < files.length; i++) {
            //   if (files[i].isDirectory) {
            //     this.downloadDir.deleteDirectory(
            //       files[i].fullPath,
            //       true,
            //       () => {
            //         platform.log('filesystem > Directory Deleted');
            //       }, (e) => {
            //         platform.log('filesystem > Error' + e.message);
            //       });
            //   }
            // }
          },
          () => { }
        );
      },
      (e) => {
        console.log('Error' + e.message);
      },
      'rw'
    );
  }

  componentWillReceiveProps({ artwork }) {
    if (artwork.id !== this.state.artwork.id) {
      this.setState({ posterImage: true });
      this.setState({ artwork });
      const video = document.getElementById('video');
      const poster = document.getElementById('poster');
      if (artwork.sourceFile !== null) {
        // Assuming ImageRotated roates by 270 deg and VideoRotated rotates by 90 deg
        if (window.innerWidth > window.innerHeight) {
          // screen is in LANDSCAPE orientation
          if (artwork.sourceFile.metadata.aspectRatio === '9:16') {
            // artwork is PORTRAIT hence APPLY rotation by 270 deg
            poster.classList.add('ImageRotated');
            video.classList.add('ImageRotated');
          } else if (artwork.sourceFile.metadata.aspectRatio === '1:1') {
            // artwork is SQUARE hence REMOVE rotation
            poster.classList.remove('ImageRotated');
            video.classList.remove('ImageRotated');
            video.style.objectFit = 'contain';
            poster.style.objectFit = 'contain';
          } else if (artwork.orientation === 'portrait') {
            poster.classList.add('ImageRotated');
          } else {
            // artwork is LANDSCAPE hence REMOVE rotation
            poster.classList.remove('ImageRotated');
            video.classList.remove('ImageRotated');
            poster.classList.remove('VideoRotated');
            video.classList.remove('VideoRotated');
            video.style.objectFit = 'cover';
          }
        } else {
          // screen is in PORTRAIT orientation
          if (artwork.sourceFile.metadata.aspectRatio === '1:1') {
            // artwork is SQUARE hence REMOVE rotation
            poster.classList.remove('ImageRotated');
            video.classList.remove('ImageRotated');
            poster.classList.remove('VideoRotated');
            video.classList.remove('VideoRotated');
            video.style.objectFit = 'contain';
            poster.style.objectFit = 'contain';
          } else if (artwork.sourceFile.metadata.aspectRatio === '9:16') {
            // artwork is PORTRAIT hence REMOVE rotation
            poster.classList.remove('VideoRotated');
            video.classList.remove('VideoRotated');
            video.style.objectFit = 'cover';
            poster.style.objectFit = 'cover';
          } else if (artwork.sourceFile.metadata.aspectRatio === '16:9' && artwork.orientation !== 'portrait') {
            // artwork is LANDSCAPE hence APPLY rotation by 90 deg
            poster.classList.add('VideoRotated');
            video.classList.add('VideoRotated');
            video.style.objectFit = 'cover';
            poster.style.objectFit = 'cover';
          } else if (artwork.sourceFile.metadata.aspectRatio === '16:9' && artwork.orientation === 'portrait') {
            // This is same as above... is it needed..?
            poster.classList.remove('VideoRotated');
            video.classList.add('VideoRotated');
            video.style.objectFit = 'cover';
            poster.style.objectFit = 'cover';
          }
        }
      }
    }
  }

  render() {
    const { artwork } = this.state;

    return (
      <div className="full-screen-carousel-item">
        <div
          className="full-screen-carousel-item__image"
          style={
            !this.props.isCurrent && !this.props.nxtPre
              ? { backgroundImage: `url(${this.getArtworkUrl(artwork)})` }
              : { background: `none` }
          }
        >
          <img
            className="poster"
            id="poster"
            src={this.getArtworkUrl(artwork)}
            style={this.state.posterImage ? { opacity: '1' } : { opacity: '0' }}
          />
          {this.state.showLoader && this.state.isCurrent ? (
            <div tabIndex="-1">
              {' '}
              <span className="spinner spinner--small loader"></span>
            </div>
          ) : null}
          {this.props.isCurrent ? (
            <video
              tabIndex="-1"
              id="video"
              src={this.getArtworkVideoUrl(artwork)}
              muted={this.state.mute ? true : false}
              autoPlay
              loop
              onPlay={() => {
                this.setState({ showLoader: false });
              }}
            ></video>
          ) : null}
          {/* {(this.props.nxtPre || this.props.other) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} muted onCanPlay={() => { this.props.loadOthers() }} poster={this.getArtworkUrl(artwork)}></video> : null} */}
        </div>
        <div className="downloadInfo" style={this.state.downloadInfo ? { display: 'block' } : { display: 'none' }}>
          {this.downloadInfoText}
        </div>
      </div>
    );
  }
}
